import { Box, ListItemIcon, MenuItem, Paper } from "@mui/material";
import React, { useContext, useState } from "react";
import { Button } from "../../../../controls";
import { useNavigate } from "react-router-dom";
import {
  BlockRounded,
  FormatQuoteRounded,
  HomeRounded,
  KeyboardReturnRounded,
  WidgetsRounded,
} from "@mui/icons-material";
import { Alert, Dialog, MenuPopup, Popover } from "../../../../layout";
import RetrieveSales from "../ParkAndRetiveSale/RetrieveSales";
import RegisterAct from "./RegisterAct";
import { Model } from "../../../../hooks";
import { CartContext } from "../POS";
import QuoteForm from "../QuoteSale/QuotesForm/QuoteForm";
import PrintQuoteReceipt from "../QuoteSale/QuotesForm/PrintQuoteReceipt";
import OpenReturn from "../../SaleReturn/OpenReturn";
import { AppContext } from "App";

const Actions = () => {
  const navigate = useNavigate();
  const { access } = useContext(AppContext);
  const { SellMdl } = Model();
  const { setCartData, cartData } = useContext(CartContext);
  const [quoteReceiptData, setQuoteReceiptData] = useState({});
  const [moreEl, setMoreEl] = useState(null);
  const [retrieveEl, setRetrieveEl] = useState(null);
  const [showQuoteForm, setShowQuoteForm] = useState(false);

  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const handleMoreAct = (e) => {
    setMoreEl(e.currentTarget);
  };

  const handleRtvSellLi = (e) => {
    setRetrieveEl(e.currentTarget);
  };

  const handleQuoteForm = () => {
    if (cartData && cartData.sellItems.length > 0) setShowQuoteForm(true);
    else
      setAlert({
        isOpen: true,
        type: "warning",
        title: "Item not found",
        subTitle: "Please first add quote items.",
      });
  };

  const handleDiscardSale = () => {
    setCartData(SellMdl);
  };

  return (
    <>
      <Paper
        className="!rounded-[20px] p-[10px] flex bg-white gap-[10px] mt-[10px]"
        sx={{
          minHeight: "80px",
          flexWrap: { xs: "wrap", md: "inherit" },
        }}
      >
        <Button
          onClick={() => navigate("/pos")}
          variant="text"
          fullWidth
          startIcon={<HomeRounded className="fs-26" />}
          sx={{ display: "block", "& .MuiButton-startIcon": { mr: 0 } }}
        >
          <span className="fs-12">Home</span>
        </Button>

        <Button
          onClick={handleRtvSellLi}
          variant="text"
          aria-describedby="retrieve_sale"
          fullWidth
          sx={{ display: "block", "& .MuiButton-startIcon": { mr: 0 } }}
          startIcon={<KeyboardReturnRounded className="fs-26" />}
        >
          <span className="fs-12">Retrieve Sale</span>
        </Button>

        <>
          <Button
            aria-controls="more_actions"
            aria-haspopup="true"
            aria-expanded="true"
            onClick={handleMoreAct}
            variant="text"
            fullWidth
            sx={{ display: "block", "& .MuiButton-startIcon": { mr: 0 } }}
            startIcon={<WidgetsRounded className="fs-24" />}
          >
            <span className="fs-12">More Actions</span>
          </Button>
          <MenuPopup
            anchorEl={moreEl}
            setAnchorEl={setMoreEl}
            id="more_actions"
            transformOrigin={{ horizontal: "center", vertical: "bottom" }}
            anchorOrigin={{ horizontal: "center", vertical: "top" }}
            className="rounded-[10px]"
          >
            {access?.pos?.returnSale && (
              <MenuItem disableRipple onClick={(e) => e.stopPropagation()}>
                <OpenReturn />
              </MenuItem>
            )}
            {access?.pos?.quote && cartData.payments.length === 0 && (
              <MenuItem onClick={handleQuoteForm}>
                <ListItemIcon>
                  <FormatQuoteRounded fontSize="small" />
                </ListItemIcon>
                Create Quote
              </MenuItem>
            )}

            <MenuItem onClick={handleDiscardSale} className="!text-red-500">
              <ListItemIcon>
                <BlockRounded fontSize="small" className="text-red-500" />
              </ListItemIcon>
              Discard Sale
            </MenuItem>
          </MenuPopup>
        </>

        {/* Register Section */}
        <RegisterAct />
      </Paper>

      {/* Retrieve Sell  */}
      <Popover
        id="retrieve_sale"
        anchorEl={retrieveEl}
        setAnchorEl={setRetrieveEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <RetrieveSales {...{ setRetrieveEl }} />
      </Popover>

      {/* Create Quote Form */}
      <Box className="d-none" id="printQuoteReceipt">
        {quoteReceiptData && quoteReceiptData.id && (
          <PrintQuoteReceipt data={quoteReceiptData} />
        )}
      </Box>
      {showQuoteForm && (
        <Dialog show={showQuoteForm} onClose={false} maxWidth="sm">
          <QuoteForm
            {...{
              setShowForm: setShowQuoteForm,
              setAlert,
              setQuoteReceiptData,
            }}
          />
        </Dialog>
      )}

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default Actions;
